import type { ShoppingCartContextProps } from 'src/app/shared/hooks/useShoppingCart';
import type {
  BrandingFeature,
  RoleRequirementsMandatoryQuestionsFeature,
  CatalogueProductFeature,
  BulletPointsFeature,
  DisplayTagFeature,
  SponsoredSlotFeature,
  StyleEnhancementFeature,
} from 'src/graphql/generated';

type FeatureTypeToTypescriptTypeMap = {
  Branding: BrandingFeature;
  BulletPoints: BulletPointsFeature;
  DisplayTag: DisplayTagFeature;
  RoleRequirementsMandatoryQuestions: RoleRequirementsMandatoryQuestionsFeature;
  SponsoredSlot: SponsoredSlotFeature;
  StyleEnhancement: StyleEnhancementFeature;
};

type FeatureType = keyof FeatureTypeToTypescriptTypeMap;

type ProductFeatures =
  | CatalogueProductFeature[]
  | ShoppingCartContextProps['cartFeatures']
  | undefined;

/**
 * Function to search and return a particular product feature
 * @param featureType Feature type to search for
 * @param productFeatures All product features
 * @returns Desired feature or undefined
 */
// NOTE Doesn't support multi tags.
// DisplayTag feature type will be treated as Urgent tag
export const getProductFeatureByType = <T extends FeatureType>({
  featureType,
  productFeatures,
}: {
  featureType: T;
  productFeatures: ProductFeatures;
}): FeatureTypeToTypescriptTypeMap[T] | undefined =>
  productFeatures?.find(
    (feature): feature is FeatureTypeToTypescriptTypeMap[T] =>
      feature?.type === featureType,
  );
